<template>
  <!--pageLoadingComplete 页面加载完毕判定-->
  <div v-if="pageLoadingComplete" class="container-wrapper" :class="is_buy ? 'container-buy' : ''">
    <GoodsDetailInfo
      :goodsData="goodsData"
      :teacherList="teacherList"
      :is_buy="is_buy"
      :unitName="unitName"
      :currentSpecs="currentSpecs"
      :productCase="productCase"
      :offlineProduct="offlineProduct"
      :titleObj="titleObj"
      @clickSpecs="specsTriggerAction()"
      @clickBuyVip="openApp()"
    />
    <!--商品内容 真题功能包-->
    <div class="goods-content" v-if="unitName == 'identity'">
      <van-tabs v-model="tabsActiveIndex" :scrollspy="true" sticky class="jbc-tabs hideTabNav">
        <van-tab v-for="(item, index) in tabsList" :title="item.name" :key="index">
          <!-- 商品目录 -->
          <div class="goods-catalog">
            <div class="container">
              <div class="header" v-if="item.listKey !== 'intro' && !is_buy">
                <span class="title">{{ item.name }}</span>
                <span class="subtitle">{{ item.list.length }}个</span>
              </div>
              <!-- 介绍页 -->
              <div class="container-row" v-if="item.listKey == 'intro'">
                <div v-html="bodyInfo(item.list)" class="imgBox"></div>
              </div>

              <CatalogList v-else :list="item.list" :type="item.listKey" :isBuy="is_buy" />
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 商品内容 非功能包-->
    <div class="goods-content" v-else>
      <van-tabs
        v-model="tabsActiveIndex"
        :scrollspy="!is_buy"
        sticky
        class="jbc-tabs"
        :class="tabsList.length <= 1 ? 'hideTabNav' : ''"
      >
        <van-tab v-for="(item, index) in tabsList" :title="item.name" :key="index">
          <!-- 商品目录 -->
          <div class="goods-catalog">
            <div class="container">
              <div class="header" v-if="item.listKey !== 'intro' && !is_buy">
                <span class="title">{{ item.name }}</span>
                <span class="subtitle">{{ item.list.length }}个</span>
              </div>
              <!-- 介绍页 -->
              <div class="container-row" v-if="item.listKey == 'intro'">
                <div v-html="bodyInfo(item.list)" class="imgBox"></div>
              </div>

              <CatalogList
                v-else
                :list="item.list"
                :type="item.listKey"
                :isBuy="is_buy"
                :no="goodsData.no"
              />
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!--商品规格选择-->
    <van-action-sheet
      v-model="isSpecsAction"
      title="规格选择"
      :closeable="false"
      class="specs-action container"
    >
      <SpecsAction
        :list="productCase.case"
        @confirmClick="specsTriggerAction"
        @change="changeSpecsItem"
        :isVipPricePower="isVipPricePower"
      />
    </van-action-sheet>

    <!-- 已购买 -->
    <template v-if="is_buy">
      <!-- 唤醒app -->
      <FooterOpenApp
        ref="footer_open_app"
        :name="getCurrentBrand.name"
        :logoImage="getCurrentBrand.imageLogoURL"
        :text="currentUnit.openAppText"
        :schemaUnitKey="currentUnit.schemaUnitKey"
      />
    </template>

    <!-- 未购买 -->
    <template v-else>
      <!-- 该课程已停售 -->
      <template v-if="goodsData.status === 5">
        <van-button :disabled="true" round type="primary" class="open-button">已停售</van-button>
      </template>

      <!-- 会员商品 -->
      <template v-else-if="isVipGoods">
        <!-- 免费领取 -->
        <FooterButtonBuy
          v-if="isFreeVipBuy"
          buttonText="会员免费学习"
          :isDisable="isDisableButton"
          :customerInfoURL="goodsCustomerUrl"
          :isVipButton="true"
          @clickButton="buy"
        />

        <!-- 提示开通 -->
        <FooterOpenApp
          ref="footer_open_app"
          :name="getCurrentBrand.name"
          :logoImage="getCurrentBrand.imageLogoURL"
          text="开通会员"
          :schemaUnitKey="currentUnit.schemaUnitKey"
          buttonText="开通"
          :style="{ display: isFreeVipBuy ? 'none' : 'block' }"
        />
      </template>

      <!-- 非会员商品 -->
      <template v-else>
        <FooterButtonBuy
          v-if="goodsData.status !== 5"
          :buttonText="buttonText"
          :isDisable="isDisableButton"
          :customerInfoURL="goodsCustomerUrl"
          @clickButton="buy"
        />
      </template>
    </template>

    <!--=================线下商品========================-->
    <van-action-sheet v-model="showAction" :closeable="false" :close="closeChange">
      <div class="actionContent">
        <p class="actionTitle">{{ titleObj.title }}</p>
        <p class="actionPriceMap">
          <span class="symbol">￥</span>
          {{ titleObj.starPrice }}
          <span class="line" v-if="titleObj.starPrice < titleObj.endPrice">-</span>
          {{ titleObj.starPrice < titleObj.endPrice ? titleObj.endPrice : '' }}
        </p>
        <div class="typeMap">
          <template
            v-if="
              offlineProduct && offlineProduct.group_list && offlineProduct.group_list.length > 0
            "
          >
            <div
              class="typeList"
              v-for="(item, index) in offlineProduct.group_list"
              :key="index + 'group_list'"
            >
              <p class="typeTitle">{{ item.name }}</p>
              <template v-if="item.option_list && item.option_list.length > 0">
                <div
                  :class="{
                    typeContent: true,
                    typeContentNoWrap: offlineProduct.group_list.length == 1,
                  }"
                >
                  <!--typeContentNoWrap 垂直摆放样式-->
                  <p
                    v-for="(childItem, childIndex) in item.option_list"
                    :key="childIndex + 'childIndex'"
                  >
                    <span
                      @click="typeClick(index, childItem.no, childItem.disableShow)"
                      :class="{
                        typeItem: true,
                        typeItemActive: childItem.isActive,
                        typeItemDisable: childItem.disableShow,
                      }"
                    >
                      {{ childItem.name }}
                    </span>
                  </p>
                </div>
              </template>
            </div>
          </template>
        </div>

        <!--购买按钮-->
        <FooterButtonBuy
          :buttonText="showModelOnes ? '去支付' : '确定'"
          :isDisable="isDisableButton"
          :customerInfoURL="goodsCustomerUrl"
          @clickButton="analyzingConditions"
        />
      </div>
    </van-action-sheet>
    <!-- 侧边打开APP悬浮按钮(停售且未购买时不显示) -->
    <SideOpenApp
      :unitKey="currentUnit.schemaUnitKey"
      :options="{ no: goodsData.no + '' }"
      v-if="goodsData.status !== 5"
    />
  </div>
</template>

<script>
import CatalogList from '@/components/Goods/CatalogList.vue'
import SpecsAction from '@/components/Goods/SpecsAction.vue'
import FooterOpenApp from '@/components/FooterOpenApp.vue'
import GoodsDetailInfo from '@/components/Goods/GoodsDetailInfo.vue'
import FooterButtonBuy from '@/components/FooterButtonBuy.vue'
import { getCourseDetail, getQuestionDetail, getIdentityDetail } from '@/api/goods/detail'
import { addFreeVirtualGoods } from '@/api/order'
import goodsOffline from '@/views/goods/mixins/goodsOffline'
import goodsCommon from '@/views/goods/mixins/goodsCommon'
import { IsPCBrowser } from '@/utils/browser'
import { getCourseDetailPcUrl } from '@/config/deviceURL'
import SideOpenApp from '@/components/SideOpenApp.vue'
export default {
  components: {
    FooterButtonBuy,
    CatalogList,
    SpecsAction,
    FooterOpenApp,
    GoodsDetailInfo,
    SideOpenApp,
  },
  mixins: [goodsOffline, goodsCommon],
  data() {
    return {
      goodsThreePoint: this.$imageURL.goodsThreePoint,
      isSpecsAction: false, //是否显示勾选规格按钮

      // 单元名称 course|question|identity
      unitName: '',
      unitNameList: {
        // 课程
        course: {
          request: getCourseDetail,
          schemaUnitKey: 'CourseDetail',
          goodsAddRequestType: 'course',
          recommendType: 'course',
          openAppText: '开始学习',
          title: '：精品课程分享',
          freeButtonText: '添加课程',
        },
        // 题集
        question: {
          request: getQuestionDetail,
          schemaUnitKey: 'QuestionSetDetail',
          goodsAddRequestType: 'questionset',
          recommendType: 'questionset',
          openAppText: '开始学习',
          title: '：精品题集分享',
          freeButtonText: '添加题集',
        },
        // 身份
        identity: {
          request: getIdentityDetail,
          schemaUnitKey: 'IdentityDetail',
          recommendType: 'identity',
          goodsAddRequestType: '',
          openAppText: '开始学习',
          title: '：精品功能包分享',
          freeButtonText: '添加功能包',
        },
      },

      goodsData: {}, // 商品数据

      tabsList: [], // tab列表数据
      tabsActiveIndex: 0, //tab选中下标

      // 商品规格
      productCase: { case: [] },
      pageLoadingComplete: false,

      // 是否禁用按钮
      isDisableButton: false,

      // 是否购买
      is_buy: false,
    }
  },

  computed: {
    // 当前单元
    currentUnit() {
      return this.unitNameList[this.unitName]
    },
    // 当前规格
    currentSpecs() {
      let caseList = this.productCase.case || []
      let result = caseList.filter((item) => {
        return item.default === 1
      })
      return result[0]
    },
    // 免费商品
    isFreeGoods() {
      return this.goodsData?.usability === 'free'
    },
    // 指定给会员的商品
    isVipGoods() {
      return this.goodsData?.usability === 'membership'
    },
    // 是否可以使用会员价购买
    isVipPricePower() {
      return !!this.goodsData.is_membership_price
    },
    // 免费会员购买
    isFreeVipBuy() {
      return this.isVipGoods && !!this.goodsData.is_buy_membership
    },
    // 按钮文案
    buttonText() {
      return this.isFreeGoods ? this.currentUnit.freeButtonText : '立即购买'
    },
    // 商品客服链接
    goodsCustomerUrl() {
      // 先取出客服列表 & 客户信息（避免重复?.）
      const serviceList = this.goodsData?.customer_service || []
      const customerInfo = this.goodsData?.customer_info

      // 优先取客服第一条，没有则取客户信息里的url
      return serviceList.length > 0 ? serviceList[0].value : customerInfo?.url
    },
  },
  created() {
    this.unitName = this.$route.params.unitName
    document.title = this.getCurrentBrand.name + this.currentUnit.title
    if (IsPCBrowser()) {
      this.toPC()
    }
    this.checkURLBuyState()
    this.getGoodsDetail()
    this.isAPP() //app内自动跳转
  },
  methods: {
    // 跳转PC界面
    toPC() {
      let pcURL = ''
      const { province, no } = this.$route.query
      const brandKey = this.getCurrentBrand.brandKey
      if (this.unitName === 'course') {
        pcURL = getCourseDetailPcUrl(brandKey, this.$route.query)
      }
      if (pcURL) {
        window.location.replace(pcURL)
      }
    },

    // 打开app
    openApp() {
      // 会员时保留当前购买状态
      if (!this.isVipGoods) {
        this.is_buy = true
      }
      this.pageLoadingComplete = true
      setTimeout(() => {
        this.$refs.footer_open_app.openApp()
      })
    },
    // 获取商品详情
    getGoodsDetail() {
      let requestGoods = this.currentUnit.request,
        params = this.routeFixedParam()

      params.no = this.$route.query.no
      // 商品请求
      requestGoods({ ...params }).then((res) => {
        if (res.status == 1 || res.status == 6001) {
          // 页面加载完成
          this.pageLoadingComplete = true

          let resData = res.data || {}
          let product = resData.product || {}
          // 当页面状态是未购买的时  刷新购买状态
          if (!this.is_buy) {
            this.updateGoodsBuySate(resData.is_buy)
          }
          /*============================= start 线下商品======================*/
          if (product.case_type == 'group') {
            this.offlineProduct = product
            this.getCopyTitle(product.case)
            this.copyTitleObj['title'] = product.name
            this.titleObj['title'] = product.name
            this.disableUpdate()
          }
          /*============================= end 线下商品======================*/
          // 初始化商品规格数据
          this.updateGoodsProduct(product)
          // 格式化商品数据
          this.dataGoodsFormatMiddle(resData)
          // 获取老师列表
          this.getTeacherDetail(resData.teacher)

          setTimeout(() => {
            this.$refs.footer_open_app.updateConfig()
          }, 100)
          // 跳转登录
        } else {
          this.$router.replace({
            name: 'emptyContent',
            query: { url: this.$route.fullPath },
          })
        }
      })
    },

    tabsListFactory(dataKeyName, name, listKey) {
      return { dataKeyName, name, listKey }
    },
    // 商品数据格式化 中间件
    dataGoodsFormatMiddle(data) {
      let unitName = this.$route.params.unitName
      let dataGoods = {}

      // 商品数据格式化
      if (unitName == 'identity') {
        dataGoods = Object.assign(data, data.rights) || {}
      } else {
        dataGoods = data
      }
      this.dataGoodsFormat(dataGoods)
    },

    // 商品数据格式化
    dataGoodsFormat(sourceData) {
      let tabsListFactory = this.tabsListFactory,
        data = sourceData,
        tabsList = [],
        contentList = [
          tabsListFactory('intro', '介绍', 'intro'),
          tabsListFactory('live_list', '直播', 'live'),
          tabsListFactory('vod_list', '录播', 'vod'),
          tabsListFactory('qv_list', '习题单', 'qv'),
          tabsListFactory('material_list', '资料', 'material'),
          tabsListFactory('course', '课程', 'identity'),
          tabsListFactory('question_set', '题集', 'identity'),
        ]

      if (this.is_buy) {
        contentList.shift()
      }
      contentList.forEach(function (item) {
        let list = data[item.dataKeyName]

        if (list && list.length > 0) {
          tabsList.push({
            name: item.name,
            listKey: item.listKey,
            list: list,
          })
        }
      })

      this.tabsList = tabsList
      this.goodsData = data
    },

    // 触发规格勾选
    specsTriggerAction() {
      this.isSpecsAction = !this.isSpecsAction
    },
    // 更改规格
    changeSpecsItem(list) {
      this.productCase.case = list
    },

    // 检查url 购买状态
    checkURLBuyState() {
      if (this.$route.query.buyState !== undefined) {
        // 更新购买状态 已购买
        this.updateGoodsBuySate(true)
      }
    },

    // 添加免费商品
    addFreeGoods() {
      let param = this.routeFixedParam()
      param.item_no = this.$route.query.no
      param.pay_type = 'free'
      if (this.currentUnit.goodsAddRequestType) {
        param.type = this.currentUnit.goodsAddRequestType
      }

      if (this.isFreeVipBuy) {
        param.pay_type = 'membership'
      }

      addFreeVirtualGoods(param).then((res) => {
        // 添加成功
        if (res.status === 1) {
          this.$toast('添加成功')
          this.getGoodsDetail()
          return
        }
        this.$toast(res.message)
      })
    },

    // 检查是否为免费商品
    checkFreeGoods() {
      // 免费课程直接添加
      if (this.isFreeGoods) {
        this.addFreeGoods()
        return true
      }
    },
    // 检查是否为会员免费购买商品
    checkVipFreeBuyGoods() {
      if (this.isFreeVipBuy) {
        this.addFreeGoods()
        return true
      }
    },
    // 检查是否为身份商品
    checkUsabilityGoods() {
      let query = this.routeFixedParam()

      // 课程类型为身份时，跳转身份详情页
      if (this.goodsData.usability === 'identity') {
        query.no = this.goodsData.identity.no
        this.$router.push({
          path: '/identity/detail',
          query,
        })
        return true
      }
    },

    // 点击购买时执行的方法
    buy() {
      if (this.isAPP()) {
        return false
      }
      if (this.checkUserNotLogin()) {
        return false
      }
      if (this.checkFreeGoods()) {
        return false
      }
      if (this.checkVipFreeBuyGoods()) {
        return false
      }
      if (this.checkUsabilityGoods()) {
        return false
      }
      // 线下课程
      if (this.offlineProduct?.case_type == 'group' && this.offlineProduct.group_list.length > 0) {
        this.showAction = true
        return
      }
      let o = {}
      o.product_no = this.productCase?.no
      o.case_id = this.currentSpecs.id
      o.count = 1
      this.goPay([o])
    },
  },

  mounted() {
    this.setupRecommendCode(this.$route.query, { rcode_range: this.currentUnit.recommendType })
  },
}
</script>

<style lang="scss" scoped>
$mainColor: var(--main-color);

/deep/ .hideTabNav {
  .van-tabs__wrap {
    display: none !important;
  }
}

.goods {
  &-card {
    padding-top: 0.2rem;
    padding-bottom: 0.5rem;

    & + & {
      border-top: 0.01rem solid #f7f8fa;
    }

    &-title {
      font-size: 0.48rem;
      line-height: 0.8rem;
      color: $color_black;
      font-weight: bold;
      margin-bottom: 0.3rem;
    }
  }

  &-catalog {
    border-bottom: 0.2rem solid #f7f8fa;
    background: #fff;

    .header {
      padding-top: 0.5rem;
      margin-bottom: -0.1rem;

      .title {
        font-size: $font36;
        font-weight: bold;
      }

      .subtitle {
        font-size: $font28;
        color: #919499;
        margin-left: 0.2rem;
      }
    }

    .image {
      display: block;
      width: 100%;
    }
  }
}

.van-tab__pane {
  &:nth-last-child(1) {
    min-height: 90vh;
    background-color: #fff;
  }
}

.van-tab__pane:nth-last-child(1) {
  .goods-catalog {
    border: none;
  }
}

.container-buy {
  .goods-catalog {
    border: none;
  }
}

.specs-action {
  padding-bottom: 0.6rem;

  .van-action-sheet__header {
    padding: 0.59rem 0;
    font-size: 0.48rem;
    line-height: 1;
    color: #18191a;
    text-align: left;
    font-weight: bold;
  }
}

.course-count {
  &-item {
    .text {
      line-height: 0.37rem;

      .icon {
        display: inline-block;
        width: 0.37rem;
        transform: translateY(0.05rem);
        margin-right: 0.2rem;
      }

      & + .text {
        margin-left: 0.5rem;
      }
    }
  }
}

/deep/ .van-sticky.van-sticky--fixed {
  @include maxWidth();
}

.buy-button {
  z-index: 100;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.65rem;
  padding-top: 0.24rem;
  padding-bottom: 0.24rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-top: 0.01rem solid #eee;
  background-color: #fff;
  @include maxWidth();

  .kefu {
    .icon {
      width: 0.53rem;
      margin-left: 0.05rem;
    }

    width: 1.7rem;
    height: 1rem;
  }
}

/deep/ .jbc-tabs {
  border-top: 0.21rem solid #f7f8fa;

  .van-tabs__wrap {
    height: 1.6rem;

    .van-tabs__nav {
      // padding-top: 0.1rem;
      padding-bottom: 0;
      box-sizing: border-box;
    }
  }

  .van-tabs__line {
    bottom: 0.2rem;
  }
}

.container-wrapper {
  padding-bottom: 1.7rem;
  min-height: 100vh;
  background-color: #fff;
  box-sizing: border-box;

  &.container-buy {
    .van-tab__pane {
      &:nth-last-child(1) {
        min-height: auto;
      }
    }
  }
}

/deep/ .imgBox img {
  max-width: 100%;
}

/*线下课程弹窗*/
.actionContent {
  padding: 0.53rem 0.53rem 1.8rem;
  min-height: 1.65rem;
  overflow: hidden;

  .actionTitle {
    font-size: 0.48rem;
    font-weight: bold;
    line-height: 0.66rem;
    color: #18191a;
    letter-spacing: 5.843277962457472 e-15px;
  }

  .actionPriceMap {
    margin-top: 0.21rem;
    padding-bottom: 0.56rem;
    border-bottom: 0.01rem solid #ebecf0;
    font-size: 0.48rem;
    font-weight: bold;
    line-height: 0.59rem;
    color: #ff6a4d;
    letter-spacing: 5.843277962457472 e-15px;

    .symbol {
      font-size: 16px;
      /*font-weight: 500;*/
    }

    .line {
      margin: 0 4px;
    }
  }

  .typeMap {
    width: 100%;
    max-height: 8.36rem;
    /*margin-top: 0.43rem;*/
    padding-top: 0.43rem;
    overflow-y: scroll;

    .typeList {
      width: 100%;
      margin-bottom: 0.56rem;

      .typeTitle {
        font-size: 0.37rem;
        font-weight: 400;
        line-height: 0.37rem;
        color: #22242e;
        letter-spacing: 5.843277962457472 e-15px;
        margin-bottom: 0.42rem;
        font-family: PingFang SC;
      }

      .typeContent {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .typeItem {
          display: inline-block;
          font-size: 0.35rem;
          font-weight: 400;
          padding: 0.16rem 0.32rem;
          background: #f7f8fa;
          font-family: PingFang SC;
          border-radius: 0.11rem;
          border: 1px solid #f7f8fa;
          margin: 0 0.32rem 0.42rem 0;
          color: #3c3d42;
        }

        .typeItemActive {
          z-index: 1;
          position: relative;
          border-color: $mainColor;
          color: $mainColor;

          &:after {
            z-index: -1;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: $mainColor;
            opacity: 0.05;
          }
        }

        .typeItemDisable {
          background-color: #f7f8fa;
          border-color: #f7f8fa;
          color: #c2c5cc;
        }
      }

      .typeContentNoWrap {
        flex-direction: column;

        .typeItem {
          width: auto;
          display: inline-block;
        }
      }
    }
  }
}
</style>
